import { Component, Host, h, Prop } from '@stencil/core';
import { BadgeColor } from './badge-interface';

/**
 * @slot - The badge's text.
 * @part badge - The component's base wrapper.
 */
@Component({
  tag: 'o2-badge',
  styleUrl: 'badge.scss',
  shadow: true,
})
export class O2Badge {
  /**
   * Sets background color of badge.
   */
  @Prop({ reflect: true }) color?: BadgeColor = 'blue';

  /**
   * Sets size of badge.
   */
  @Prop() size?: 'small' | 'medium' = 'medium';

  render() {
    const badgeColor = this.color ? `badge--${this.color}` : '';
    const badgeSize = this.size ? `badge--${this.size}` : '';

    return (
      <Host>
        <div class={`badge ${badgeColor} ${badgeSize}`} part="badge">
          <div class="badge__text">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
